import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { adminApi } from "@/lib/adminApi";

const AdminAuthContext = createContext(null);

export function AdminAuthProvider({ children }) {
  const [admin, setAdmin] = useState(undefined); // undefined = checking, null = logged out, obj = logged in

  const check = useCallback(async () => {
    const token = localStorage.getItem("balance_admin_token");
    if (!token) {
      setAdmin(null);
      return;
    }
    try {
      const { data } = await adminApi.get("/auth/me");
      setAdmin(data);
    } catch {
      localStorage.removeItem("balance_admin_token");
      setAdmin(null);
    }
  }, []);

  useEffect(() => {
    check();
  }, [check]);

  const login = async (email, password) => {
    const { data } = await adminApi.post("/auth/login", { email, password });
    localStorage.setItem("balance_admin_token", data.token);
    setAdmin(data.user);
    return data.user;
  };

  const logout = () => {
    localStorage.removeItem("balance_admin_token");
    setAdmin(null);
  };

  return (
    <AdminAuthContext.Provider value={{ admin, login, logout }}>
      {children}
    </AdminAuthContext.Provider>
  );
}

export const useAdminAuth = () => useContext(AdminAuthContext);
